import React from 'react';

import Leaf from '../../icons/Leaf';
import Seedling from '../../icons/Seedling';
import HatChef from '../../icons/HatChef';
import PepperHot from '../../icons/PepperHot';
import NewIcon from '../../icons/NewIcon';
import GlutenFree from '../../icons/GlutenFree';
import LactoseFree from '../../icons/LactoseFree';
import SugarFree from '../../icons/SugarFree';
import IconWithPopover from '../common/IconWithPopover';

const lime = { color: '#82c91e' };
const hot = { color: '#ff3f3f' };
const primary = { color: 'var(--primary)' };
const blue = { color: '#91c2ff' };

const faSizeStyle = { width: 20 };
const doubleFaSize = { width: 18 };
const trippleFaSize = { width: 16 };
const roundSizeStyle = { width: 26 };

const lactoseStyle = {
  color: '#4eb1e8',
  ...roundSizeStyle,
};
const glutenStyle = {
  color: '#cba704',
  ...roundSizeStyle,
};
const sugarStyle = {
  color: '#e44ba0',
  ...roundSizeStyle,
};

const dishLabelStyles = {
  new: <NewIcon style={{ ...primary, width: 24 }} />,
  recommended: <HatChef style={{ ...blue, ...faSizeStyle }} />,
  vege: <Leaf style={{ ...lime, ...faSizeStyle }} />,
  vegan: <Seedling style={{ ...lime, ...faSizeStyle, }} />,
  hot: <PepperHot style={{ ...hot, ...faSizeStyle }} />,
  'very-hot': <><PepperHot style={{ ...hot, ...doubleFaSize }} /><PepperHot style={{ ...hot, ...doubleFaSize }} /></>,
  'max-hot': <><PepperHot style={{ ...hot, ...trippleFaSize }} /><PepperHot style={{ ...hot, ...trippleFaSize }} /><PepperHot style={{ ...hot, ...trippleFaSize }} /></>,
  'lactose-free': <LactoseFree style={lactoseStyle} />,
  'gluten-free': <GlutenFree style={glutenStyle} />,
  'sugar-free': <SugarFree style={sugarStyle} />,
};

const DishLabel = ({ label }) => {
  const { name, value } = label;
  const icon = dishLabelStyles[value];
  return <IconWithPopover text={translateDishName(name)} icon={icon} className="ml-1" />;
}

const knownDishNamesPL = {
  'new': 'Nowość',
  'recommended': 'Szef kuchni poleca',
  'vege': 'Wege',
  'vegan': 'Vegan',
  'hot': 'Ostre (1/3)',
  'very-hot': 'Średnio ostre (2/3)',
  'max-hot': 'Max Ostre (3/3)',
  'gluten-free': 'Bez glutenu',
  'lactose-free': 'Bez laktozy',
  'sugar-free': 'Bez cukru'
};

function translateDishName(dishName) {
  return knownDishNamesPL[dishName] || dishName;
}

export default DishLabel;
